import { render, staticRenderFns } from "./SimpleAlertModal.vue?vue&type=template&id=4823cc2a&scoped=true"
import script from "./SimpleAlertModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SimpleAlertModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SimpleAlertModal.vue?vue&type=style&index=0&id=4823cc2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4823cc2a",
  null
  
)

export default component.exports